// user-status.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../mainService/user.service';

@Injectable({
  providedIn: 'root',
})
export class UserStatusService {
  private _userStatus: BehaviorSubject<any>;
  public userStatus$;
  public isStatusSetManually = true;

  constructor(private userService: UserService) {
    const savedStatus = localStorage.getItem('userStatus') || 'available';
    this._userStatus = new BehaviorSubject<string>(savedStatus);
    this.userStatus$ = this._userStatus.asObservable();
  }

  updateUserStatus(status: any) {
    this._userStatus.next(status);
    // localStorage.setItem('userStatus', status);

    // Check if the status is 'busy' and update it accordingly
    if (status === 'busy') {
      console.log('User is now busy.');
    }

    // this.userService.setUserStatus(status).subscribe(
    //   () => {
    //     console.log('User status updated successfully.');
    //   },
    //   (error: any) => {
    //     console.error('Error updating user status:', error);
    //   }
    // );
  }

  getUserStatusFromApi() {
    // this.userService.getUserStatus().subscribe(
    //   (status: any) => {
    //     this._userStatus.next(status);
    //   },
    //   (error: any) => {
    //     console.error('Error getting user status from API:', error);
    //   }
    // );
  }

  setManualStatus(status: string) {
    this.isStatusSetManually = true;
    this.updateUserStatus(status);
  }
  getCurrentUserStatus(): string {
    return this._userStatus.getValue();
  }
}
